import Accordion from 'components/Accordion';
import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import Value from 'components/Value';
import {PeppolRecipient} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {t} from 'ttag';

type SendViaPeppolSendProps = {
    isSelected: boolean;
    recipient?: PeppolRecipient;
};

const SendViaPeppolSend: FC<SendViaPeppolSendProps> = ({
    isSelected,
    recipient,
}) => {
    if (!isSelected) return null;

    return (
        <Accordion
            header={
                <div className="flex items-center gap-2">
                    <h2 className="m-0 flex items-center gap-2 p-0">
                        {t`Peppol Send`}
                    </h2>
                </div>
            }
            hideDividerIfLast={true}
            id="send-via-peppol-send"
            isOpenByDefault={true}
        >
            <KeyValue className="text-base" keyWidth={10}>
                <Field label={t`Send to`} type="value">
                    {recipient && (
                        <Value
                            value={{
                                type: 'tags',
                                value: [
                                    {
                                        color: 'blue',
                                        label: recipient.name,
                                        tooltip: recipient.participantId,
                                    },
                                ],
                            }}
                        />
                    )}
                </Field>
            </KeyValue>
        </Accordion>
    );
};

export default SendViaPeppolSend;
